window.CompanyNotes = {
    init(modalName) {
        this.handleShow(modalName);
        this.handleButtonClicks(modalName);
    },

    handleShow(modalName) {
        $(document).on('show.bs.modal', `#${modalName}`, () => {
            const modal = $(`#${modalName}`);
            // Clear all inputs
            modal.find('#create-note-section textarea').val('');
            modal.find('#create-note-section #note').val('');
            modal.find('#create-note-section #private-checkbox').prop('checked', false);
            modal.find('#create-note-section #buyer-checkbox').prop('checked', false);

            modal.find('.js-note-display').addClass('d-flex').removeClass('d-none');
            modal.find('.js-note-edit').addClass('d-none').removeClass('d-flex');

            // Reset filters
            const filterButtons = modal.find('.filter-button');
            filterButtons.removeClass('active');
            modal.find("#notes-filter-all").addClass('active');
            CompanyNotes.filterByCategory(modal, 'all');

            CompanyNotes.markViewed(modal, modalName);
        })
    },

    markViewed(modal, modalName) {
        const noteIds = modal.find('[id^="company-note-"]').map(function () {
            return this.id.replace('company-note-', '');
        }).get();

        if (noteIds.length === 0) return;

        $.ajax({
            url: '/company_notes/mark_viewed',
            type: 'POST',
            data: { company_note_ids: noteIds },
            success: function () {
                $(`[data-target="#${modalName}"] .notes-badge`).remove();
            }
        });
    },

    handleButtonClicks(modalName) {
        const modal = $(`#${modalName}`);
        modal.find('#add-note-btn').click(() => {
            modal.find('#create-note-section').removeClass('d-none').addClass('d-flex');
        });

        modal.find('#cancel-note-btn').click(() => {
            modal.find('#create-note-section').removeClass('d-flex').addClass('d-none');
        });

        const filterButtons = modal.find('.filter-button');
        filterButtons.click(function () {
            filterButtons.removeClass('active');
            $(this).addClass('active');

            const filterId = $(this).data('filter-id');
            CompanyNotes.filterByCategory(modal, filterId);
        });

        // Event delegation: works for existing + newly inserted notes
        modal.on('click', '.js-delete-note', function () {
            const noteId = $(this).data('company-note-id');

            $.ajax({
                url: `/company_notes/${noteId}`,
                type: 'DELETE',
                success: function () {
                    modal.find('#company-note-' + noteId).remove();
                },
                error: function () {
                    console.error('Failed to delete note:', noteId);
                }
            });
        });

        modal.on('click', '.js-edit-note', function () {
            const noteId = $(this).data('company-note-id');
            const note = modal.find('#company-note-' + noteId);
            note.find('.js-note-display').addClass('d-none').removeClass('d-flex');
            note.find('.js-note-edit').addClass('d-flex').removeClass('d-none');
        });

        modal.on('click', '.js-cancel-edit-note-btn', function () {
            const noteId = $(this).data('company-note-id');
            const note = modal.find('#company-note-' + noteId);
            note.find('.js-note-display').addClass('d-flex').removeClass('d-none');
            note.find('.js-note-edit').addClass('d-none').removeClass('d-flex');
        });

        modal.find('#save-note-btn').click(() => {
            let authorTeamId = modal.find('#create-note-section #author_team_id').val();
            const subjectTeamId = modal.find('#create-note-section #subject_team_id').val();
            const dataSystemDealMatchId = modal.find('#create-note-section #data_system_deal_match_id').val();
            const dealId = modal.find('#create-note-section #deal_id').val();
            const buyerTeamId = modal.find('#create-note-section #buyer_team_id').val();
            const noteText = modal.find('#create-note-section #note').val();
            const isPrivate = modal.find('#create-note-section #private-checkbox').is(':checked');
            const visibleToBuyer = modal.find('#create-note-section #buyer-checkbox').is(':checked');

            // switch the author team to a buyer team so that kwayga admins can write buyer notes
            // authorization is confirmed in the CreateCompanyNote service
            if(visibleToBuyer === true) {
                authorTeamId = buyerTeamId;
            }

            $.ajax({
                url: `/company_notes`,
                type: 'POST',
                dataType: 'json',
                data: {
                    company_note: {
                        author_team_id: authorTeamId,
                        subject_team_id: subjectTeamId,
                        data_system_deal_match_id: dataSystemDealMatchId,
                        deal_id: dealId,
                        note: noteText,
                        private: isPrivate
                    }
                },
                success: function (data) {
                    if (data && data.html) {
                        modal.find('#company-notes-empty').remove();
                        modal.find('#company-notes-list').prepend(data.html);

                        // reset + hide form
                        modal.find('#create-note-section #note').val('');
                        modal.find('#create-note-section #private-checkbox').prop('checked', false);
                        modal.find('#create-note-section #buyer-checkbox').prop('checked', false);
                        modal.find('#create-note-section').addClass('d-none').removeClass('d-flex');

                        // keep current filter consistent after insertion
                        const activeFilterId = modal.find('.filter-button.active').data('filter-id') || 'all';
                        CompanyNotes.filterByCategory(modal, activeFilterId);
                    }
                },
                error: function (xhr) {
                    console.error('Failed to save note', xhr.responseText);
                }
            });
        });

        modal.on('click', '.js-update-note-btn', function () {
            const noteId = $(this).data('company-note-id');
            const noteCard = modal.find('#company-note-' + noteId);
            const noteText = noteCard.find(`#note_${noteId}`).val();
            const isPrivate = noteCard.find(`#private_${noteId}`).is(':checked');

            $.ajax({
                url: `/company_notes/${noteId}`,
                type: 'PATCH',
                dataType: 'json',
                data: {
                    note: noteText,
                    private: isPrivate
                },
                success: function (data) {
                    console.debug('Successfully updated note', data);
                    if (data && data.html) {
                        noteCard.replaceWith(data.html);
                    }
                },
                error: function (xhr) {
                    console.error('Failed to update note', xhr.responseText);
                }
            });
        });
    },

    filterByCategory(modal, filterId) {
        const noteCards = modal.find('.card');
        noteCards.each(function () {
            const card = $(this);
            const isPrivate = card.find('#private_note').val() === 'true';
            switch (filterId) {
                case 'all':
                    card.removeClass('d-none');
                    break;
                case 'my-notes':
                    isPrivate ? card.removeClass('d-none') : card.addClass('d-none');
                    break;
                case 'team-notes':
                    isPrivate ? card.addClass('d-none') : card.removeClass('d-none');
                    break;
            }
        });
    },
}
